<template>
  <div class="grid justify-items-center">
    <img
      :src="logoUrl"
      alt="Vetster logo"
      class="w-18 h-12 mt-6"
    />
    <h2 class="font-title font-bold text-2xl text-center mt-8">
      {{ title }}
    </h2>
  </div>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {

  name: 'VetsterLogoTitle',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    logoUrl() {
      return getAssetUrl('images/vetster-logo-accent-pink.svg');
    },
  },
};
</script>
